import { createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { API_ADD_ADMIN_RESTAURANT, API_APPROVE_RESTAURANT, API_ARCHIVED_VENUE_LIST, API_ARCHIVE_VENUE, API_BASE, API_DELETE_ADMIN_RESTAURANT, API_EXPORT_VENUES_CSV, API_FRANCHISE_TOGGLE, API_GET_ALL_FRANCHISE_LIST, API_LIST_ADMIN_RESTAURANT, API_MERGE_VENUES, API_MERGE_VENUES_PREVIEW, API_REPORTED_RESTAURANT, API_REPORTED_RESTAURANT_ACTIVE, API_RESOLVED_REPORTED_RESTAURANT, API_RESTAURANT_REQUEST_LIST, API_RESTORE_VENUE, API_VENUE_UNCLAIM, GET_APPROVE_RESTAURANT_DETAIL, GET_DETAIL_ADMIN_RESTAURANT } from '../constants/index'


const initialState = {
    isLoading: false,
    isLoggedIn: false,
    restaurntRequestDetail: {},
    approvedRestList: { data: [], recordsTotal: 0 },
    reportedRestaurantList: { data: [], recordsTotal: 0 },
    archivedVenueList: { list: [], recordsTotal: 0 },
    sidebarShow: true,
    skip: 0,
    limit: 10,
}

//APPROVE restaurant 
export const approveRestaurant = (data) => ({
    type: 'API',
    payload: {
        url: API_APPROVE_RESTAURANT,
        method: 'POST',
        data: data,
        hideLoader: false,
        success: (data) => ({
            type: 'approveRestaurant/success',
            payload: data,
        }),
        error: (data) => ({
            type: 'approveRestaurant/fail',
            payload: {},
        }),
    },
})

//approve reject request
export const getApproveRestaurantList = (data) => ({
    type: 'API',
    payload: {
        url: API_RESTAURANT_REQUEST_LIST,
        method: 'POST',
        data: data,
        hideLoader: false,
        success: (data) => ({
            type: 'getApprovedRestaurantList/success',
            payload: data,
        }),
        error: (data) => ({
            type: 'getApprovedRestaurantList/fail',
            payload: {},
        }),
    },
})



//Get restaurnat Detail Action
export const getRestaurantRequestDetail = (data) => ({
    type: 'API',
    payload: {

        url: GET_APPROVE_RESTAURANT_DETAIL,
        method: 'POST',
        data: data,
        hideLoader: false,
        success: (data) => ({
            type: 'getRestaurantRequestDetail/success',
            payload: data,
        }),
        error: (data) => ({
            type: 'getRestaurantRequestDetail/fail',
            payload: {},
        }),
    },
})
export const ADDRestauantByADmin = (data) => ({
    type: 'API',
    payload: {

        url: API_ADD_ADMIN_RESTAURANT,
        method: 'POST',
        data: data,
        hideLoader: false,
    },
})
export const ListRestauantByADmin = (data) => ({
    type: 'API',
    payload: {
        url: API_LIST_ADMIN_RESTAURANT,
        method: 'POST',
        data: data,
        hideLoader: false,
        success: (data) => ({
            type: 'getRestaurants/success',
            payload: data,
        }),

    },
})

export const DELETERestaurant = (data) => ({
    type: 'API',
    payload: {
        url: API_DELETE_ADMIN_RESTAURANT,
        method: 'DELETE',
        data: data,
        hideLoader: false,
    },
})

export const UnclaimVenue = (data) => ({
    type: 'API',
    payload: {
        url: API_VENUE_UNCLAIM,
        method: 'POST',
        data: data
    }
})

//Get reported restaurant List Action
export const getReportedRsetaurantList = (data) => ({
    type: 'API',
    payload: {
        url: API_REPORTED_RESTAURANT,
        method: 'POST',
        data: data,
        hideLoader: false,
        success: (data) => ({
            type: 'reportedRestaurantList/success',
            payload: data,
        }),
        error: (data) => ({
            type: 'reportedRestaurantList/fail',
            payload: {},
        }),
    },
})

//Resolved reported restaurant 
export const resolvedReportedRestaurant = (data) => ({
    type: 'API',
    payload: {
        url: API_RESOLVED_REPORTED_RESTAURANT,
        method: 'POST',
        data: data,
        hideLoader: false,
        success: (data) => ({
            type: 'resolvedRestaurant/success',
            payload: data,
        }),
        error: (data) => ({
            type: 'resolvedRestaurant/fail',
            payload: {},
        }),
    },
})

export const reportedRestaurantActiveInactive = (data) => ({
    type: 'API',
    payload: {
        url: API_REPORTED_RESTAURANT_ACTIVE,
        method: 'PATCH',
        data: data,
        hideLoader: false,
        success: (data) => ({
            type: 'activeInactive/success',
            payload: data,
        }),
        error: (data) => ({
            type: 'activeInactive/fail',
            payload: {},
        }),
    }
})

export const getAllFranchiseList = (data) => ({
    type: 'API',
    payload: {
        url: API_GET_ALL_FRANCHISE_LIST,
        method: 'GET',
        data: data,
        hideLoader: false,
        success: (data) => ({
            type: 'getAllFranchiseList/success',
            payload: data,
        }),
        error: (data) => ({
            type: 'getAllFranchiseList/fail',
            payload: {},
        }),
    },
})

export const updateFrnachiseToggle = (data) => ({
    type: 'API',
    payload: {
        url: API_FRANCHISE_TOGGLE,
        method: 'PATCH',
        data: data,
        hideLoader: false,
        success: (data) => ({
            type: 'updateFranchiseToggle/success',
            payload: data,
        }),
        error: (data) => ({
            type: 'updateFranchiseToggle/fail',
            payload: {},
        }),
    },
})

// GRB-1360: fetch full venue details for the Merge Workspace (master + each
// duplicate). Existing endpoint (getRestaurantDetails), not previously wired
// into this slice.
export const getRestaurantDetailAction = (data) => ({
    type: 'API',
    payload: {
        url: GET_DETAIL_ADMIN_RESTAURANT,
        method: 'POST',
        data: data,
        hideLoader: true,
    },
})

// GRB-1360: Merge preview — obtains a signed previewToken and authoritative
// impact counts (goats, routing blockers) required before executing a merge.
export const mergeVenuesPreviewAction = (data) => ({
    type: 'API',
    payload: {
        url: API_MERGE_VENUES_PREVIEW,
        method: 'POST',
        data: data,
        hideLoader: true,
        success: (data) => ({
            type: 'mergeVenuesPreview/success',
            payload: data,
        }),
        error: (data) => ({
            type: 'mergeVenuesPreview/fail',
            payload: {},
        }),
    },
})

// GRB-1360: Intelligent Duplicate Merger
export const mergeVenuesAction = (data) => ({
    type: 'API',
    payload: {
        url: API_MERGE_VENUES,
        method: 'POST',
        data: data,
        hideLoader: false,
        success: (data) => ({
            type: 'mergeVenues/success',
            payload: data,
        }),
        error: (data) => ({
            type: 'mergeVenues/fail',
            payload: {},
        }),
    },
})

// GRB-1360: Archive & Recovery
export const archiveVenueAction = (data) => ({
    type: 'API',
    payload: {
        url: API_ARCHIVE_VENUE,
        method: 'POST',
        data: data,
        hideLoader: false,
        success: (data) => ({
            type: 'archiveVenue/success',
            payload: data,
        }),
        error: (data) => ({
            type: 'archiveVenue/fail',
            payload: {},
        }),
    },
})

export const restoreVenueAction = (data) => ({
    type: 'API',
    payload: {
        url: API_RESTORE_VENUE,
        method: 'POST',
        data: data,
        hideLoader: false,
        success: (data) => ({
            type: 'restoreVenue/success',
            payload: data,
        }),
        error: (data) => ({
            type: 'restoreVenue/fail',
            payload: {},
        }),
    },
})

export const getArchivedVenueListAction = (data) => ({
    type: 'API',
    payload: {
        url: API_ARCHIVED_VENUE_LIST,
        method: 'POST',
        data: data,
        hideLoader: false,
        success: (data) => ({
            type: 'archivedVenueList/success',
            payload: data,
        }),
        error: (data) => ({
            type: 'archivedVenueList/fail',
            payload: {},
        }),
    },
})

// GRB-1360: Structured CSV Export
// A thunk, not the standard {type:'API'} action — the generic middleware always
// requests JSON (no responseType override, uses `data` even for GET), which
// can't correctly receive a streamed CSV file. This calls axios directly with
// responseType:'blob' and downloads it via a hidden <a>, matching the pattern
// already used elsewhere in this app for object URLs (AddNotification.js).
//
// exportType='current': downloads a CSV of exactly the search+pagination
// window currently on screen (start/length/search all forwarded to the BE).
// exportType='full': the backend builds the whole database and emails it as
// an attachment instead of streaming a download — no blob/download here,
// just the success message (returned so the caller can toast it).
export const exportVenuesCSVAction = ({ exportType, search, start, length }) => async (dispatch) => {
    dispatch(loaderChange(true))
    try {
        if (exportType === 'full') {
            const res = await axios.get(API_EXPORT_VENUES_CSV, {
                baseURL: API_BASE,
                params: { exportType },
            })
            dispatch(loaderChange(false))
            return res.data
        }

        const res = await axios.get(API_EXPORT_VENUES_CSV, {
            baseURL: API_BASE,
            params: { exportType, search, start, length },
            responseType: 'blob',
        })

        const url = URL.createObjectURL(res.data)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'venues_filtered.csv')
        document.body.appendChild(link)
        link.click()
        link.remove()
        URL.revokeObjectURL(url)

        dispatch(loaderChange(false))
    } catch (err) {
        dispatch(loaderChange(false))
        throw err
    }
}

// Reducer
const getRestaurantSlice = createSlice({
    name: 'getRestaurntList',
    initialState: initialState,
    reducers: {
        loaderChange: (state, action) => {
            state.isLoading = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase('set', (state, action) => {
            state.sidebarShow = action.payload
        })
        builder.addCase('getRestaurants/success', (state, action) => {
            state.restaurantList = action.payload.data.data
            state.recordsTotal = action.payload.data.recordsTotal
        })
        builder.addCase('getApprovedRestaurantList/success', (state, action) => {
            state.approvedRestList = action?.payload?.data
        })
        builder.addCase('getApprovedRestaurantList/fail', (state, action) => {
            state.approvedRestList = { data: [], recordsTotal: 0 }
            state.isLoggedIn = false
        })

        builder.addCase('getRestaurantRequestDetail/success', (state, action) => {
            state.restaurntRequestDetail = action.payload.data

        })
        builder.addCase('getRestaurantRequestDetail/fail', (state, action) => {
            state.restaurntRequestDetail = {}
            state.isLoggedIn = false
        })
        builder.addCase('reportedRestaurantList/success', (state, action) => {
            state.reportedRestaurantList = action?.payload?.data
        })
        builder.addCase('reportedRestaurantList/fail', (state, action) => {
            state.reportedRestaurantList = { data: [], recordsTotal: 0 }
            state.isLoggedIn = false
        })
        builder.addCase('getAllFranchiseList/success', (state, action) => {
            state.getAllFranchiseList = action.payload.data
        })
        builder.addCase('getAllFranchiseList/fail', (state, action) => {
            state.getAllFranchiseList = { data: [], recordsTotal: 0 }
            state.isLoggedIn = false
        })
        builder.addCase('archivedVenueList/success', (state, action) => {
            state.archivedVenueList = action?.payload?.data
        })
        builder.addCase('archivedVenueList/fail', (state, action) => {
            state.archivedVenueList = { list: [], recordsTotal: 0 }
        })
    },
})

export const { loaderChange } = getRestaurantSlice.actions
export default getRestaurantSlice.reducer
